import { useDashboardStore } from '@/stores/dashboardStore';
import DrillTable from './tables/DrillTable';

export default function DrillModal() {
  const { modal, closeModal } = useDashboardStore();

  if (!modal.open) return null;

  return (
    <div className="modal-overlay open" onClick={closeModal}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{modal.title}</span>
          <button className="modal-close" onClick={closeModal}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <DrillTable
            title=""
            columns={modal.columns}
            data={modal.data}
            onCustomerClick={(customerName, row) => {
              console.log('Customer clicked:', customerName, row);
            }}
          />
        </div>
      </div>
    </div>
  );
}
